import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useState } from "react";
export const useHandleTreeView = (param)=>{
    let { categoryId , categoryMenu  } = param;
    //category id만 바뀌어도 열려야 한다.
    const { push  } = useRouter();
    //상위 카테고리 아이디 찾기
    const findParents = useCallback((targetId)=>{
        let parents = [];
        if (!targetId) return parents;
        const depth = targetId.length / 2;
        for(let i = 0; i < depth; i++){
            parents.push(targetId.slice(0, 2 * i));
        }
        return parents;
    }, []);
    const [expandedItems, setExpandedItems] = useState([
        ...findParents(categoryId)
    ]);
    const [selectedItem, setSelectedItem] = useState([
        categoryId || ""
    ]);
    const handleSelectedItemsChange = useCallback((_, ids)=>{
        setSelectedItem(ids);
    }, [
        setSelectedItem
    ]);
    const handleExpandedItemsChange = useCallback((_, ids)=>{
        setExpandedItems(ids);
    }, [
        setExpandedItems
    ]);
    const depth = useMemo(()=>{
        if (!categoryId) return 0;
        return categoryId.length / 2;
    }, [
        categoryId
    ]);
    const goTo404 = useCallback(()=>{
        push("/404");
    }, []);
    const isValidId = useCallback((categoryId)=>{
        if (!categoryId) return true;
        const regex = /^(?:\d{2}|\d{4}|\d{6}|\d{8}|\d{10})$/;
        return regex.test(categoryId);
    }, []);
    const changeTreeItems = useCallback((items, categoryId)=>{
        handleExpandedItemsChange(null, [
            ...findParents(categoryId),
            items && categoryId
        ]);
        handleSelectedItemsChange(null, [
            categoryId
        ]);
    }, []);
    //children이 있을 경우 tree를 오픈 맟 카테고리에 없는 id일경우 404, gnb에서 id가 변경되었을 경우 tree를 열어줘야한다.
    useEffect(()=>{
        if (!isValidId(categoryId)) {
            goTo404();
            return;
        }
        if (categoryMenu) {
            //categoryId = 1001
            let items = categoryMenu;
            //depth = 2depth
            for(let i = 1; i <= depth; i++){
                //1001 -> 10
                let currentId = categoryId.slice(0, 2 * i);
                let currentCategory = items.find((item)=>"id" in item ? item.id === currentId : item.categoryId === currentId);
                if (!currentCategory) {
                    goTo404();
                    return;
                }
                //마지막 depth인 경우
                if (i === depth) {
                    changeTreeItems(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.items, categoryId);
                    return;
                }
                items = currentCategory.items;
            }
        }
    }, [
        categoryMenu,
        categoryId
    ]);
    return {
        expandedItems,
        handleSelectedItemsChange,
        handleExpandedItemsChange,
        selectedItem,
        findParents
    };
};
